import React from "react";
import { useSearchParams } from "react-router-dom";
import { Text } from "@noom/wax-component-library";

import { NoomAcknowledgementIntakePage } from "../components/NoomAcknowledgementIntakePage";
import { MixpanelTypes } from "../common/types";

function getMedicationName(programVersion: string | null): string {
  if (programVersion === "MED_COMPOUNDED") return "compounded semaglutide";
  if (programVersion === "MED_TIRZEPATIDE") return "compounded tirzepatide";
  return "compounded medication";
}

export const PharmacySwitchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const medicationName = getMedicationName(searchParams.get("programVersion"));

  return (
    <NoomAcknowledgementIntakePage
      title="Important Notice: Your Pharmacy is Changing"
      intakeType="PHARMACY_SWITCH"
      mixpanelEventName={MixpanelTypes.PharmacySwitchConfirmed}
      errorTestId="pharmacy-switch-error"
      confirmButtonLabel="I understand, continue"
    >
      <Text size="md" fontWeight="400" marginTop="16px" display="block">
        The pharmacy that dispenses your {medicationName} is changing. Some of
        the details about your prescription may be changing, if prescribed by
        your doctor. Please read the following information carefully.
      </Text>

      <Text size="md" fontWeight="700" marginTop="16px" display="block">
        What May Be Different:
      </Text>
      <Text size="md" fontWeight="400" marginTop="8px" display="block">
        <strong>Compound Additive</strong> – The additive used in your{" "}
        {medicationName} may have changed.
      </Text>
      <Text size="md" fontWeight="400" marginTop="8px" display="block">
        <strong>Concentration</strong> – The concentration of your vial and the
        number of units you inject may have changed.
      </Text>
      <Text size="md" fontWeight="400" marginTop="8px" display="block">
        <strong>Syringes</strong> – The syringes included in your shipment may
        look different. Please refer to the informational card included in your
        box for a detailed explanation of any differences.
      </Text>

      <Text size="md" fontWeight="700" marginTop="16px" display="block">
        What You Should Do:
      </Text>
      <Text size="md" fontWeight="400" marginTop="8px" display="block">
        If your doctor prescribes the new medication, they will send an updated
        treatment plan, please review this carefully to understand any changes
        and how to properly administer your new prescription. We are committed
        to making this transition as smooth as possible.
      </Text>

      <Text size="md" fontWeight="700" marginTop="16px" display="block">
        Have Questions?
      </Text>
      <Text size="md" fontWeight="400" marginTop="8px" display="block">
        If you have any questions or concerns, please reach out to your care
        coordinator through in-app messaging and we will be happy to assist you.
      </Text>
    </NoomAcknowledgementIntakePage>
  );
};
